import { Badges, StudyDetailsResponse } from "./api";
import { capitalizeString } from "./format";

export interface StudySnapshotFields {
  keyTakeaway?: string;
  population?: string | null;
  sampleSize?: number | null;
  studyCount?: number | null;
  methods?: string | null;
  outcomes?: string | null;
  results?: string | null;
  country?: string[] | null;
  duration?: string | null;
}

export type StudySnapshotFieldNameType = keyof StudySnapshotFields;

export function countNonEmptySnapshotFields(fields: StudySnapshotFields) {
  let count = 0;
  if (fields.population) count++;
  if (fields.sampleSize || fields.studyCount) count++;
  if (fields.methods) count++;
  if (fields.outcomes) count++;
  if (fields.results) count++;
  if (fields.country && fields.country.length) count++;
  if (fields.duration) count++;
  return count;
}

function isValueEmpty(value?: string | number | null) {
  return !value || value === "" || value === "n/a";
}

export function parseStudyDetailsResponse(
  response?: StudyDetailsResponse | null,
  badges?: Badges
): StudySnapshotFields {
  return {
    population: isValueEmpty(response?.population)
      ? null
      : response?.population,
    methods: isValueEmpty(response?.method) ? null : response?.method,
    outcomes: isValueEmpty(response?.outcome) ? null : response?.outcome,
    results: isValueEmpty(response?.result) ? null : response?.result,
    country: response?.country?.length ? response.country : null,
    duration: isValueEmpty(response?.duration) ? null : response?.duration,
    sampleSize: badges?.sample_size ? badges.sample_size : null,
    studyCount: badges?.study_count ? badges.study_count : null,
  };
}

export function isStudySnapshotEmpty(
  response: StudyDetailsResponse,
  badges?: Badges
): boolean {
  const studySnapshot = parseStudyDetailsResponse(response, badges);
  return countNonEmptySnapshotFields(studySnapshot) === 0;
}

export const displayFieldList = (
  value: string[] | string | undefined | null | number
): string | null | undefined | number => {
  if (Array.isArray(value)) {
    if (value.length === 1) {
      return value[0];
    }
    if (value.length === 2) {
      return value[0] + " and " + value[1];
    }
    if (value.length > 2) {
      const valueCopy = [...value];
      return (
        valueCopy.splice(0, value.length - 1).join(", ") +
        " and " +
        value[value.length - 1]
      );
    }
    return null;
  } else {
    return value;
  }
};

export const formatStudySnapshotValue = (
  id: string,
  value: string | string[] | number | undefined | null
) => {
  if (id === "country") {
    return (value as string[]).map((country: string) => {
      if (country.toLowerCase() === "usa") {
        return "USA";
      }
      if (country.toLowerCase() === "uk") {
        return "UK";
      }
      return capitalizeString(country);
    });
  }
  return value;
};
